import { render } from "./BaDifference.vue?vue&type=template&id=6d9721be&ts=true"
import script from "./BaDifference.vue?vue&type=script&lang=ts"
export * from "./BaDifference.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__